import { useLeavesQuery } from "@/graphql/generated";
import { leafLabel } from "@/lib/attributeReview/kindWords";

export type FoundField = {
  path: string;
  label: string;
  folder: string;
  usedByStores: Record<string, number>;
};

export function useFindFields(query: string, folder: string | null) {
  const { data, isLoading } = useLeavesQuery(
    query || folder
      ? { query: query || undefined, folder: folder ?? undefined }
      : undefined,
  );
  const fields: FoundField[] = (data?.leaves ?? []).map((leaf) => ({
    path: leaf.path,
    label: leaf.label ?? leafLabel(leaf.leaf),
    folder: leaf.folder,
    usedByStores: (leaf.usedByStores ?? {}) as Record<string, number>,
  }));
  return { fields, loading: isLoading };
}
